/** Team Flow 图片缓存 Service Worker 的根路径脚本地址。 */
const IMAGE_CACHE_SW_URL = '/image-cache-sw.js';

let registerPromise: Promise<ServiceWorkerRegistration | null> | null = null;

/** 注册画布媒体缓存 SW；开发环境同样注册以支持本地调试，不支持环境下静默跳过。 */
export function registerImageCacheServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }
  if (!registerPromise) {
    registerPromise = navigator.serviceWorker.register(IMAGE_CACHE_SW_URL, { scope: '/' })
      .catch((error) => {
        console.warn('[TeamFlow image SW] register failed, fallback to direct fetch:', error);
        return null;
      });
  }
  return registerPromise;
}
